module.exports = __webpack_public_path__ + "img/dashboard.d7b614ff.png";